import { motion } from 'framer-motion'
import { HiMail, HiPhone } from 'react-icons/hi'
import { SectionTitle } from '@/components/SectionTitle'
import { ContactForm } from '@/components/ContactForm'
import { useLanguage } from '@/i18n/LanguageContext'

const EMAIL = 'comercial@envprocess.com'
const PHONE = '(11) 96821-4305'
const PHONE2 = '(11) 92507-9542'
const PHONE3 = '(351) 939 453 739'
const PHONE4 = ' (351) 912 902 034'
const PHONE5 = '(11) 98083-1931'

export function Contato() {
  const { t } = useLanguage()

  return (
    <section id="contato" className="section-padding bg-slate-50">
      <div className="container-custom">
        <SectionTitle
          title={t.contato.title}
          subtitle={t.contato.subtitle}
        />
        <div className="grid lg:grid-cols-3 gap-12 lg:gap-16">
          <motion.div
            className="lg:col-span-1 space-y-6"
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: '-50px' }}
            transition={{ duration: 0.5 }}
          >
            <p className="text-slate-600 leading-relaxed">
              {t.contato.description}
            </p>
            <div className="space-y-4">
              <a
                href={`mailto:${EMAIL}`}
                className="flex items-center gap-3 text-slate-700 hover:text-primary-600 transition-colors"
              >
                <HiMail className="h-5 w-5 shrink-0" />
                <span>{EMAIL}</span>
              </a>
              <a
                href={`tel:${PHONE.replace(/\D/g, '')}`}
                className="flex items-center gap-3 text-slate-700 hover:text-primary-600 transition-colors"
              >
                <HiPhone className="h-5 w-5 shrink-0" />
                <span>{PHONE}</span>
             
              </a>
              <a
                href={`tel:${PHONE2.replace(/\D/g, '')}`}
                className="flex items-center gap-3 text-slate-700 hover:text-primary-600 transition-colors"
              >
                <HiPhone className="h-5 w-5 shrink-0" />
                <span>{PHONE2}</span>
              </a>
              <a
                href={`tel:${PHONE3.replace(/\D/g, '')}`}
                className="flex items-center gap-3 text-slate-700 hover:text-primary-600 transition-colors"           >
                <HiPhone className="h-5 w-5 shrink-0" />
                <span>{PHONE3}</span>
              </a>
              <a
                href={`tel:${PHONE4.replace(/\D/g, '')}`}
                className="flex items-center gap-3 text-slate-700 hover:text-primary-600 transition-colors"           >
                <HiPhone className="h-5 w-5 shrink-0" />
                <span>{PHONE4}</span>
              </a>
              <a
                href={`tel:${PHONE5.replace(/\D/g, '')}`}
                className="flex items-center gap-3 text-slate-700 hover:text-primary-600 transition-colors"           >
                <HiPhone className="h-5 w-5 shrink-0" />
                <span>{PHONE5}</span>
              </a>
            </div>
          </motion.div>
          <motion.div
            className="lg:col-span-2 rounded-2xl bg-white p-6 md:p-8 shadow-sm border border-slate-200/80"
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: '-50px' }}
            transition={{ duration: 0.5 }}
          >
            <ContactForm />
          </motion.div>
        </div>
      </div>
    </section>
  )
}
